import { Flex, Text, RadioGroup, RadioButton } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ArenaLockAction } from "../constants";
import { isArenaLockAction } from "../utils";
import * as styles from "./styles_vanilla.css";

type ActionSelectorProps = {
  selectedAction: ArenaLockAction;
  isLoading: boolean;
  isComplete: boolean;
  onActionChange: (action: ArenaLockAction) => void;
};

export const ActionSelector = ({
  selectedAction,
  isLoading,
  isComplete,
  onActionChange,
}: ActionSelectorProps) => {
  return (
    <div className={styles.configurationSection}>
      <Flex alignItems="center" gap={Sizes.SM} className={styles.sectionHeaderFlex}>
        <Icon type="cog" size="medium" color={Colors.Primary600} />
        <Text variant="strong-md" className={styles.sectionTitle}>
          Select Action
        </Text>
      </Flex>
      <Text variant="secondary-md" className={styles.sectionDescription}>
        Choose whether to lock or unlock the arena:
      </Text>

      <RadioGroup
        name="selectedAction"
        onChange={(e) => {
          const value = e.target.value;
          if (isArenaLockAction(value)) {
            onActionChange(value);
          }
        }}
      >
        <Flex alignItems="center" gap={Sizes.SM}>
          <RadioButton
            value={ArenaLockAction.LOCK}
            checked={selectedAction === ArenaLockAction.LOCK}
            disabled={isLoading || isComplete}
            name="selectedAction"
          >
            <Flex alignItems="center" gap={Sizes.XS}>
              <Icon type="lock" size="small" color={Colors.Danger600} />
              <Text variant="secondary-md">Lock Arena</Text>
            </Flex>
          </RadioButton>
        </Flex>
        <Flex alignItems="center" gap={Sizes.SM}>
          <RadioButton
            value={ArenaLockAction.UNLOCK}
            checked={selectedAction === ArenaLockAction.UNLOCK}
            disabled={isLoading || isComplete}
            name="selectedAction"
          >
            <Flex alignItems="center" gap={Sizes.XS}>
              <Icon type="key" size="small" color={Colors.Success600} />
              <Text variant="secondary-md">Unlock Arena</Text>
            </Flex>
          </RadioButton>
        </Flex>
      </RadioGroup>
    </div>
  );
};
